import React from "react";
import { FaQuoteLeft } from "react-icons/fa";
import starIcon from "../../static/images/star-icon.png";

const testimonials = [
  {
    industry: "Professional Services",
    service: "Microsoft 365 Collaboration & Security Framework",
    outcome: "More secure and organised SharePoint collaboration",
    text: "CloudLogic IT Solutions implemented a digital collaboration and security framework for our business, along with SharePoint sites that improved team collaboration and efficiency. Their approach made our operations more secure and organised.",
    name: "Sagar Kumar Sharma",
    role: "Director",
    organisation: "Sincere Migration And Education",
  },
  {
    industry: "Education",
    service: "School Microsoft 365 Tenant, Users & Licensing",
    outcome: "Reliable Microsoft tenant, domain, licensing, and cyber awareness support",
    text: "CloudLogic IT Solutions helped our school create a Microsoft tenant, set up Microsoft 365 users and AD accounts, and liaised with Microsoft to secure the right licences for our school domain. Their support has been reliable, responsive, and professional.",
    name: "Prabinda Khanal",
    role: "School Incharge",
    organisation: "Annapurna Vidya Sadan",
  },
];

const Testimonials = () => {
  return (
    <section className="testimonials-area pt-100 pb-100">
      <div className="container">
        <div className="section-title">
          <span className="sub-title">
            <img src={starIcon} alt="testimonial" />
            Testimonials
          </span>

          <h2>Proof From Organisations Using Microsoft Cloud</h2>

          <p>
            Real examples from organisations that needed cleaner Microsoft
            cloud operations, safer collaboration, practical security guidance,
            and stronger technology governance.
          </p>
        </div>

        <div className="proof-card-grid">
          {testimonials.map((item, index) => (
            <article className="proof-card" key={index}>
              <div className="proof-card-top">
                <span className="proof-industry">{item.industry}</span>
                <FaQuoteLeft />
              </div>

              <h3>{item.service}</h3>

              <p>{item.text}</p>

              <div className="proof-outcome">
                <span>Outcome</span>
                <strong>{item.outcome}</strong>
              </div>

              <div className="proof-client">
                <h4>{item.name}</h4>
                <span>
                  {item.role}, {item.organisation}
                </span>
              </div>
            </article>
          ))}

          <article className="proof-card proof-card-cta">
            <span className="proof-industry">How CloudLogic Builds Trust</span>
            <h3>Clear Findings, Practical Fixes, Plain-English Reporting</h3>
            <p>
              Every review should help leaders understand what is exposed, what
              matters most, and what to fix first across Microsoft cloud,
              identity, sharing, and governance controls.
            </p>

            <ul>
              <li>Microsoft 365 and Azure control gap snapshot</li>
              <li>Identity, MFA, sharing, and governance priorities</li>
              <li>Remediation roadmap leaders can actually use</li>
            </ul>
          </article>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
